import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesContent } from "../../constants/enums";
import { FAQListItem } from "../../content.types";
import { UpdateFaqItemRequestBody } from "./updateFaqItem.types";

export const requestUpdateFaqItem = async ({
  id,
  ...body
}: UpdateFaqItemRequestBody): Promise<FAQListItem> => {
  return await instance.patch(buildUrl(ApiRoutesContent.FAQItems, id), body);
};
